<div class="container">
    <div class="basicrow m-top-i roboto-r text-center">
        <div class="shortcont">
            <div class="basicrow f-black text-center noacc-icon">
                <i class="fa fa-frown-o" aria-hidden="true"></i>
            </div>
            <div class="basicrow f-reg f-black m-top-ii roboto-b text-center">
                No tienes productos Claro en este segmento.
            </div>
            <div class="basicrow m-top-i">
                <a href="/modifyaccounts/1"class="btns red ascbtn-i centr vcenter">
                    <span class="tabcell">
                        Agrega tus Productos Claro Aquí&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>